<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 24">
    <g id="logout" transform="translate(1 1)">
      <g id="Group_1445" data-name="Group 1445">
        <line
          id="Line_320"
          data-name="Line 320"
          x1="12"
          transform="translate(0 11)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Path_4895"
          data-name="Path 4895"
          d="M21,16l-4-4,4-4"
          transform="translate(-17 -1)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Path_4896"
          data-name="Path 4896"
          d="M5,4V3A2,2,0,0,1,7,1H17a2,2,0,0,1,2,2V21a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V20"
          transform="translate(-3 -1)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
    </g>
  </svg>
</template>
